<div class="states-info-dialog">
  <header class="dialog-header">
    <div>
      <span class="eyebrow">Operations · Programación</span>
      <h2>Información de Estados de File</h2>
      <p>
        Consulta el flujo completo sin duplicar estados. Cada fila muestra dónde
        se ve el estado y qué área puede ejecutar el siguiente paso.
      </p>
    </div>
    <button mat-icon-button type="button" aria-label="Cerrar" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="summary-grid">
    <article class="summary-card operations">
      <mat-icon>engineering</mat-icon>
      <div>
        <strong>Operations</strong>
        <span>Cambios manuales desde Programación.</span>
      </div>
    </article>
    <article class="summary-card sales">
      <mat-icon>storefront</mat-icon>
      <div>
        <strong>Sales</strong>
        <span>Cambios manuales del flujo comercial.</span>
      </div>
    </article>
    <article class="summary-card system">
      <mat-icon>schedule</mat-icon>
      <div>
        <strong>Sistema</strong>
        <span>Cambios automáticos por fechas de operación.</span>
      </div>
    </article>
  </section>

  <section class="states-section">
    <div class="section-title">
      <mat-icon>account_tree</mat-icon>
      <h3>Flujo consolidado de estados</h3>
    </div>
    <div class="phase-list">
      <article class="phase-card" *ngFor="let group of stateGroups">
        <div class="phase-header">
          <div>
            <h4>{{ group.title }}</h4>
            <p>{{ group.description }}</p>
          </div>
        </div>

        <div class="state-list">
          <article class="state-row" *ngFor="let item of group.states">
            <div class="state-main">
              <div class="state-heading">
                <strong>{{ item.state }}</strong>
                <span class="next-chip visibility-chip">
                  Visible: {{ getVisibilityText(item) }}
                </span>
              </div>
              <p>{{ item.description }}</p>
              <div class="state-hint">
                <mat-icon>tips_and_updates</mat-icon>
                <span>{{ item.userHint }}</span>
              </div>
            </div>

            <div class="state-actions">
              <div class="action-card operations-action" *ngIf="item.operationsNextStates.length > 0">
                <span>Operations puede pasar a</span>
                <strong>{{ item.operationsNextStates.join(', ') }}</strong>
              </div>
              <div class="action-card sales-action" *ngIf="item.salesNextStates.length > 0">
                <span>Sales puede pasar a</span>
                <strong>{{ item.salesNextStates.join(', ') }}</strong>
              </div>
              <div class="action-card system-action" *ngIf="item.automaticNextStates.length > 0">
                <span>El sistema cambia a</span>
                <strong>{{ item.automaticNextStates.join(', ') }}</strong>
              </div>
              <div class="action-card neutral-action" *ngIf="!hasAnyAction(item)">
                <span>Sin cambio configurado</span>
                <strong>No requiere acción desde esta pantalla</strong>
              </div>
            </div>
          </article>
        </div>
      </article>
    </div>
  </section>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-raised-button type="button" class="close-button" (click)="close()">
      Entendido
    </button>
  </mat-dialog-actions>
</div>
